import Vue from 'vue'
import Vuex from 'vuex'
import bus from '@/helpers/bus'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    }
  },
  getters: {
    isGuest: state => {
      return state.user && state.user.isAnonymous
    }
  },
  actions: {
    handleFirebaseError: (_, error) => {
      if (error.code && (error.code.indexOf('unauthorized') > -1 || error.code.indexOf('PERMISSION_DENIED') > -1)) {
        bus.$emit('snackbar', 'Permission Denied!')
      }
    }
  },
  modules: {
  }
})
